import React, { Component } from 'react';

// Modules
import { Auth } from 'aws-amplify';
import queryString from 'query-string';
import cloneDeep from 'lodash/cloneDeep';
import FormValidator from 'utils/FormValidator';
import CustomValidators from 'utils/CustomValidators';

// Material UI
import { withStyles } from '@material-ui/core/styles';

// Components
import AuthHeader from 'components/AuthHeader';
import AuthForm from 'components/AuthForm';
import Button from 'components/Button';
import Input from 'components/Input';

// Styles
import styles from './styles';

class ResetPassword extends Component {
    INIT = {
        code: { value: '', valid: true },
        password: { value: '', valid: true },
        passwordMatch: { value: '', valid: true },
    };
    constructor(props) {
        super(props);

        const query = queryString.parse(props.location.search);
        // take back to reset password if no email in query
        if (!query.email) this.props.history.replace('/forgot-password');

        this.state = {
            ...cloneDeep(this.INIT),
            email: query.email,
            loading: false,
        };
    }

    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }

    async handleResetPassword(e) {
        e.preventDefault();
        const { handleError } = this.props;

        const invalidFields = FormValidator(this.refs, this.updateField.bind(this));

        if (invalidFields.length > 0) {
            return handleError(invalidFields[0].message);
        }

        this.mounted && this.setState({ loading: true });
        try {
            await Auth.forgotPasswordSubmit(this.state.email, this.state.code.value, this.state.password.value);
            this.props.setSnackbar('Password has been updated');
            this.props.history.replace('/');
        } catch (error) {
            handleError(error);
        }
        this.mounted && this.setState({ loading: false });
    }

    updateField = ({ field, value, valid = true, expectedType }) => {
        const form = this.state;
        // Check and make sure the type of field is the same as the INIT
        if (value !== null && value !== undefined) {
            if (typeof this.INIT[field].value === typeof value || expectedType === typeof value) {
                form[field].value = value;
            }
        }
        form[field].valid = valid;

        this.mounted && this.setState({ [field]: form[field] });
    };

    render() {
        const { loading } = this.state;
        const { classes } = this.props;

        return (
            <AuthForm className={classes.authForm} onSubmit={this.handleResetPassword.bind(this)}>
                <Input
                    id="email"
                    ref="email"
                    label="Email Address"
                    disabled={true}
                    fullWidth={true}
                    marginBottom={12}
                    value={this.state.email}
                />
                <Input
                    id="code"
                    ref="code"
                    label="Code"
                    fullWidth={true}
                    marginBottom={12}
                    value={this.state.code.value}
                    onChange={(e) =>
                        this.updateField({
                            field: 'code',
                            value: e.target.value,
                        })
                    }
                    validator={() => !!this.state.code.value}
                    error={!this.state.code.valid}
                    errorMessage="Please provide a valid code"
                />
                <Input
                    id="password"
                    ref="password"
                    label="Password"
                    type="password"
                    fullWidth={true}
                    marginBottom={12}
                    value={this.state.password.value}
                    onChange={(e) =>
                        this.updateField({
                            field: 'password',
                            value: e.target.value,
                        })
                    }
                    validator={() => CustomValidators.testPassword(this.state.password.value)}
                    error={!this.state.password.valid}
                    errorMessage="Password must be at least 8 characters, contain at least 1 uppercase and 1 lowercase character, as well as one numeric character"
                />
                <Input
                    id="passwordMatch"
                    ref="passwordMatch"
                    label="Confirm Password"
                    type="password"
                    fullWidth={true}
                    marginBottom={12}
                    value={this.state.passwordMatch.value}
                    onChange={(e) =>
                        this.updateField({
                            field: 'passwordMatch',
                            value: e.target.value,
                        })
                    }
                    validator={() => this.state.password.value === this.state.passwordMatch.value}
                    error={!this.state.passwordMatch.valid}
                    errorMessage="Passwords do not match"
                />

                <input ref="formSubmit" type="submit" style={{ display: 'none' }} />

                <Button
                    color="primary"
                    disabled={loading}
                    fullWidth={true}
                    onClick={this.handleResetPassword.bind(this)}
                    size="large"
                    text={'Reset Password'}
                    variant="contained"
                />
            </AuthForm>
        );
    }
}

export default withStyles(styles)(ResetPassword);
